/**
 * TripNavButtons · v2.8.6
 * ─────────────────────────
 * The two-step native-navigation control for driver trips. Opens the
 * driver's PREFERRED maps app (Google / Apple / device default — via the
 * shared `openNavigation` helper + `rtg_map_pref`):
 *   · "Navigate to Pickup"   → routes to the pickup address (step 1)
 *   · "Navigate to Drop-off" → routes to the drop-off address (step 2)
 *
 * The in-app GPS map (LiveTripNav) is intentionally NOT used — every
 * navigation hand-off goes out to the device's native maps app.
 */
import { Button } from "@/components/ui/button";
import { MapPin, Flag } from "lucide-react";
import { toast } from "sonner";
import { openNavigation } from "@/components/NavigateButton";

export default function TripNavButtons({
  pickup,
  dropoff,
  size = "sm",
  testidPrefix = "trip-nav",
  className = "",
}) {
  const goPickup = () => {
    if (!pickup) return toast.error("No pickup address on this trip");
    openNavigation(pickup);
  };
  const goDropoff = () => {
    if (!dropoff) return toast.error("No drop-off address on this trip");
    openNavigation(dropoff, pickup || null);
  };
  return (
    <div className={`flex gap-2 ${className}`}>
      <Button
        type="button"
        size={size}
        onClick={goPickup}
        data-testid={`${testidPrefix}-pickup`}
        className="flex-1 bg-emerald-500 hover:bg-emerald-400 text-zinc-950 font-bold"
      >
        <MapPin className="h-4 w-4 mr-1.5" />
        Navigate to Pickup
      </Button>
      <Button
        type="button"
        size={size}
        variant="outline"
        onClick={goDropoff}
        data-testid={`${testidPrefix}-dropoff`}
        className="flex-1 bg-zinc-950 border-amber-400/50 text-amber-300 hover:bg-amber-400/10 font-bold"
      >
        <Flag className="h-4 w-4 mr-1.5" />
        Navigate to Drop-off
      </Button>
    </div>
  );
}
